import React from "react";
import WhatIsItsme from "./components/what-is-itsme/what-is-itsme";
import { Grid, Hidden } from "@material-ui/core";

import LoginBySp from "./components/login-by-sp/login-by-sp";
import "./login.scss";
import LoginMultipleType from "./components/login-multiple-types/login-multiple-type";
import LoginLogo from "assets/images/png/LoginLogo.png";
import config from '../../config';
import GridSpacing from "components/grid/GridSpacing";

import { useHistory } from "react-router";

type UrlParams = {
    authTypes: string[];
    spName: string;
    sp: string;
    acs: string;
};

export const getLoginParameterFrom = (searchParam: string): UrlParams => {
    const queryParams = new URLSearchParams(searchParam);
    const aAuthType = queryParams.get("pi2.aAuthType");
    const pi2sp = queryParams.get("pi2.sp");
    const pi2acs = queryParams.get("pi2.acs");

    let authTypes: string[] = [];
    let spName = "";
    let sp = "";
    let acs = "";

    if (pi2sp === null || pi2acs === null) {
        throw new Error("Missing pi2acs or pi2sp");
    }

    // Check if url contains SP
    if (pi2sp !== null) {
        const spArray = pi2sp.split("=");
        const spLast = spArray[spArray.length - 1];
        sp = spLast;
        const spSplit = spLast.split("/");
        const spSplitLast = spSplit[spSplit.length - 1];
        spName = `${spSplitLast.substring(0, 1).toUpperCase()}${spSplitLast.substring(1, spSplitLast.length)}`;
    }

    acs = pi2acs.replace(`${config.PI2_ACS}=`, "");

    if (aAuthType !== null) {
        let aAuthTypeArray = aAuthType.split(";");
        aAuthTypeArray = aAuthTypeArray.slice(1, aAuthTypeArray.length - 1);
        authTypes = aAuthTypeArray;
    }

    return {
        authTypes,
        spName,
        sp,
        acs,
    };
};

const LoginPage = (): React.ReactElement => {
    const history = useHistory();
    let urlParams = null;

    try {
        urlParams = getLoginParameterFrom(window.location.search);
    } catch (error) {
        history.push("/onboarding");
        return <></>;
    }

    return (
        <Grid container justifyContent="center" spacing={1}>
            <Grid item xs={11} md={5}>
                <LoginBySp
                    sp={urlParams.spName}
                    spFull={urlParams.sp}
                    authType={urlParams.authTypes}
                    acs={urlParams.acs}
                />
            </Grid>
            <Grid item xs={12} md={5}>
                {urlParams.authTypes.length === 1 ? (
                    <Hidden mdDown>
                        <img src={LoginLogo} alt="login logo" className="login-simple-logo" />
                    </Hidden>
                ) : (
                    <LoginMultipleType
                        spFull={urlParams.sp}
                        authType={urlParams.authTypes.join(";")}
                        acs={urlParams.acs}
                    />
                )}
            </Grid>
            <GridSpacing size={100} />
            <div
                style={{
                    borderTop: "1px solid #e8ebeb",
                    width: "100%",
                    marginTop: "-2.8em",
                }}
            />
            <Grid item xs={12}>
                <WhatIsItsme />
            </Grid>
            <GridSpacing size={80} />
        </Grid>
    );
};

export default LoginPage;
